const faqsPurchase = [
  {
    question: "How to buy a reviewer subscription?",
    answer: "You can view all available offers by selecting the Buy a Subscription button located in the top-right of the Reviewers page. Then, choose your preferred reviewer and click Get Access. Payment instructions will appear immediately after.",
  },
  {
    question: "What is your mode of payment?",
    answer: "We accept payments via GCash. A GCash QR code will be displayed for you to scan and send your payment. After completing the transaction, please take a screenshot as proof of payment.\nHowever, only the input of the 13-digit Reference Code in the final payment step is required to proceed. We will request the screenshot only if there are issues with verifying your payment.",
  },
  {
    question: "What if I don’t have GCash?",
    answer: "If you don't have a GCash account, you can still pay using other e-wallets, bank transfer apps, or payment centers (e.g., 7-Eleven), as long as they support QR code scanning. You may also transfer directly using the provided GCash mobile number on the payment page. In this case, please upload a screenshot or photo of the successful transaction during the final payment step (as an alternative to providing the 13-digit reference code).",
  },
  {
    question: "Do you accept credit cards?",
    answer: "Not at the moment. Our system currently does not support credit card payments. We will announce it once this option becomes available.",
  },
  {
    question: "How long until my payment is confirmed?",
    answer: "Expect the payment confirmation process within 24 hours. You can reach us via support@skilltech.ph if you have any questions or concerns.",
  },
  {
    question: "What happens after my payment is confirmed?",
    answer: "Once your payment is confirmed, you’ll receive a system-generated email sent to the Skilltech-linked email address on your account. This email will include a detailed breakdown of your purchase.",
  },
  {
    question: "Can I buy the reviewer now and activate it later?",
    answer: "Yes. This is a feature of our platform wherein you can buy the reviewers to take advantage of a sale but you can activate it later whenever you are ready. The duration (i.e. expiration) will only start from the date you activated the reviewer.",
  },
  {
    question: "What does “Activate” mean?",
    answer: "Your reviewer’s duration (3 months or 1 month) only begins once you press the activate button.",
  },
  {
    question: "Do you give out refunds?",
    answer: "Refunds are subject to evaluation. We do not give out refunds if the reviewer has already been activated.",
  },
  {
    question: "Do you grant free extensions?",
    answer: "No, we do not grant free extensions. Simply subscribe again if you think you need more time to review or if you haven't completed your exams.",
  },
  {
    question: "Can I get a discount if I renew my subscription?",
    answer: "Yes, this is possible. Contact our support team at support@skilltech.ph or FB page for assistance.",
  },
  {
    question: "Can I purchase multiple reviewers?",
    answer: "Yes, you can buy each one of them individually or in the bundle reviewers we offer at a much lesser price.",
  },
  {
    question: "Can I sell my account or have it rented after I finish my exams early?",
    answer: "No. This is in violation of our terms of service. However, we understand that you want to help out your friends and family, or you want to earn through our platform. With that in mind, we highly suggest you apply as a Skilltech Endorser. That way, you can earn even more and not get tied up to just one account.",
  },
  {
    question: "What is a Skilltech Endorser?",
    answer: "A Skilltech Endorser is an affiliate program by Skilltech to help us grow and reach more users. Skilltech Endorsers enjoy commissions on each sale they make as well as other perks like bonuses, exclusive merch, sponsorships, etc. To learn more about this, reach out to us via support@skilltech.ph",
  },
]

const faqsLeaderboardChallenge = [
  {
    question: "What is a Leaderboard Challenge?",
    answer: "This is an event where all Skilltech users compete against each other to reach the Top 10 of the Season’s leaderboard. The winners of the challenge win various prizes which include fully-paid technical training, CAAP exam expense allowances, cash reward, refunds, and more. ",
  },
  {
    question: "What is a Season?",
    answer: "Various challenges will be released at a different time, with different themes, and with different types of mechanics. Each of these events will be introduced in the form of a Season.",
  },
  {
    question: "How do I win in these challenges?",
    answer: "All you have to do is to collect as much Skillpoints as you can before the Season period ends. The one that collects the most wins the grand prize.",
  },
  {
    question: "What is the goal of the Leaderboard Challenge?",
    answer: "Skilltech is always finding ways to help our young Filipino AMTs and AVTs become more successful in their fields. By launching events like these, we are hoping to encourage our users to master their exams more. ",
  },
  {
    question: "Why should I join the challenge?",
    answer: "We mostly reward our users with aviation-related prizes. By doing so, they will gain the much-needed advantage in kick-starting their careers – while steadily mastering your Licensure and MTP exams at the same time."
  },
]

const faqsCaapLicenseTracker = [
  {
    question: "What is a CAAP License Tracker?",
    answer: "This is a feature of the app wherein you can see the planned date and the current status of your CAAP Licensure journey.",
  },
  {
    question: "How can this feature benefit me?",
    answer: "This will help you remember your goals, particularly the time factor involved in getting your AMT or AVT license. In our research, users who constantly see their target dates most likely finish their exams on time. In some instances, even earlier.",
  },
  {
    question: "Why should I update my CAAP Info?",
    answer: "If you want to change the planned date of your exams, or finally give us the good news that you’ve successfully passed all the subjects, you can easily do that by updating your CAAP Info. Regularly updating this helps us understand our users more. The more info we get, the more we can improve the overall experience of our users.",
  },
  {
    question: "After finishing my exam, why should I choose to upload my test results?",
    answer: "Aside from getting a large amount of Skillpoints, uploading your CAAP Test Results actually helps us keep our reviewers more accurate. By giving us the percentages of your ratings, and the times it took you to pass each subject for the actual CAAP exam, we can pinpoint which part of the reviewer needs immediate improvement.",
  },
]

const faqsReviewers = [
  {
    question: "What are Skilltech Reviewers?",
    answer: "These are strategically created reviewers that will help you pass the required exams to become successful Aircraft Mechanics.",
  },
  {
    question: "What type of reviewers do you have?",
    answer: "We currently offer 3 reviewers: The CAAP Knowledge, CAAP Practical, and MTP Entrance. Detailed descriptions of each are shown in the reviewer section of the app.",
  },
  {
    question: "What is a Practice Test?",
    answer: "The Practice Test is the first part of the reviewer, where you can freely choose specific subtopics to study. It includes score counters to help you track your progress. You can also save your progress at any time and return to it whenever you like.",
  },
  {
    question: "What are Subtopics?",
    answer: "An exam (e.g., the CAAP Knowledge Test) is typically divided into major sections called Subjects. Each Subject covers various areas, which are further broken down into smaller, more specific units known as Subtopics.",
  },
  {
    question: "What are progress bars for?",
    answer: "Progress bars show you the percentage of items you’ve completed within a subtopic, helping you track how much you’ve already covered.",
  },
  {
    question: "What are Key Subtopics?",
    answer: "Through our continuous research, we found that certain subtopics appear more frequently in the actual exam. Because of this, we’ve tagged these as Key Subtopics to help you focus on the areas that can have the greatest impact on your review.",
  },
  {
    question: "Should I only focus on the Key Subtopics?",
    answer: "Don’t rely solely on the Key Subtopics. The app marks certain subtopics with a key icon to highlight those that are more likely to appear on the exam. They’re helpful, but they’re meant only as extra guidance. In the actual exam, all subtopics can still appear—so it’s best to study everything to avoid getting caught off guard.",
  },
  {
    question: "What are Duplicate Subtopics?",
    answer: "Some subtopics appear in more than one subject. For example, Landing Gears can be found under both Airframe Rating and Aircraft Maintenance. These are labeled as Duplicate Subtopics. This feature helps you review more efficiently by preventing you from studying the same material twice—your progress in one will automatically sync with the other.",
  },
  {
    question: "What is a Mock Exam?",
    answer: "The Mock Exam is the second part of the reviewer, designed to assess how well you’ve mastered the topics you’ve studied. It includes time limits, passing scores, and other features that simulate the experience of taking a real exam.",
  },
  {
    question: "Where did you base the time limits and passing scores?",
    answer: "These are based on our research of the most recent standards used by relevant examination bodies (e.g., CAAP AEB).",
  },
  {
    question: "Do scores and time limits change?",
    answer: "Yes. To ensure our standards remain accurate and up to date, these numbers may change as new information becomes available from our research team. Be sure to check our announcements for any updates.",
  },
  {
    question: "Do the Mock Exams work like the real exams?",
    answer: "Yes. Our Mock Exams function similarly to real exams. The system randomly selects items from the standard coverage of each subject, just as actual exam systems do. Our randomization algorithms are also based on research into the most commonly encountered items reported by our successful users.",
  },
  {
    question: "If I pass a Mock Exam once, does it mean I will pass the real exam too?",
    answer: "Passing our Mock Exams—especially if you do so consistently—can improve your chances of performing well on the real exam, since our Passer Milestones are modeled after actual exam standards. However, we cannot guarantee results, as success in the real test depends on many factors.",
  },
  {
    question: "How will I maximize the benefits of the Mock Exams?",
    answer: "We strongly recommend taking the Mock Exams regularly—regardless of your score—to expose yourself to as many item combinations as possible. This repeated practice helps build familiarity, confidence, and mastery over time.",
  },
];

const faqsMilestonesAchievements = [
  {
    question: "What are Milestones?",
    answer: "Milestones are sets of conditions placed within each Mock Exam subject (e.g., Air Law). You can unlock them by meeting or surpassing specific score and time requirements.",
  },
  {
    question: "What are Achievements?",
    answer: "Achievements are special goals assigned to each Reviewer Category (e.g., CAAP License Knowledge Test). You can unlock them by completing specific sets of Milestones within that category.",
  },
  {
    question: "What happens when I unlock a Milestone?",
    answer: "Unlocking a Milestone rewards you with Skillpoints, which contribute to improving your Overall Ranking. Completing certain sets of Milestones will also unlock corresponding Achievements that grant even larger Skillpoint rewards.",
  },
  {
    question: "What happens when I unlock an Achievement?",
    answer: "You’ll earn an Achievement Badge, which will be added to your personal dashboard. You’ll also receive a larger amount of Skillpoints, giving your Overall Ranking a significant boost.",
  },
  {
    question: "What are Skillpoints?",
    answer: "Skillpoints are part of Skilltech’s point system, used to rank users in the Nationwide Overall Ranking.",
  },
  {
    question: "How can I earn Skillpoints?",
    answer: "You can earn Skillpoints by unlocking various Milestones and Achievements found in the Mock Exams.",
  },
  {
    question: "What are the basis for the passing rates and time limits (Passer Milestone)?",
    answer: "The criteria for all Passer Milestones are based on our research into the current standards used across the aviation industry today.",
  },
  {
    question: "What are Speedrunner and Master Milestones?",
    answer: "Speedrunner and Master Milestones are special benchmarks created by Skilltech to help you sharpen your exam skills. They focus on two key components of our simulated mock exams: achieving higher scores and completing exams more quickly.",
  },
]

const faqsLeaderboards = [
  {
    question: "What are Leaderboards?",
    answer: "Leaderboards are a ranking system created by Skilltech that allows you to see how your performance compares with other users. Their main purpose is to foster a sense of competitiveness and community by connecting you with others who are at the same stage of their career journey.",
  },
  {
    question: "Do other users see my rank?",
    answer: "Yes. Other users can see your rank, but only if you are in the Top 20 of any category.",
  },
  {
    question: "How do I improve my Overall Ranking?",
    answer: "You can improve your Overall Ranking by earning Skillpoints, which you gain by completing various Milestones and Achievements in the Mock Exams.",
  },
  {
    question: "Are there real-life rewards for topping the Overall Ranking?",
    answer: "Aside from ultimate bragging rights, we are currently developing a reward system that will offer top rankers real-life aviation-related perks. These may include sponsored aviation training programs, all-expense-paid CAAP license acquisition, full refunds for Skilltech Reviewers, and more. This initiative is part of our mission to help build successful careers within the aviation community. Stay tuned for upcoming announcements.",
  },
  {
    question: "Do I earn Skillpoints for ranking higher?",
    answer: "No. You currently cannot earn Skillpoints simply by ranking higher. Skillpoints can only be earned by completing Milestones and Achievements. However, we are developing a reward system for Leaderboards, which we’ll be announcing in the coming months.",
  },
  {
    question: "How are ratings being computed?",
    answer: "Ratings are calculated using a 50:50 ratio based on two factors: your Score Percentage and your Time-Left Percentage (not the time you consumed).",
  },
  {
    question: "How do Leaderboards help me in my review?",
    answer: "Many exam takers lose momentum due to lack of motivation or not having a clear reference for their progress. Leaderboards help keep you engaged by giving you a meaningful way to gauge your performance against other active users. This provides both motivation and a clearer sense of where you stand in your learning journey.",
  },
];

const faqsABox = [
  {
    question: "What is an Achievement Box (A-box)?",
    answer: "This is Skilltech’s special way to congratulate our users on passing their CAAP Licensure Exam.",
  },
  {
    question: "Is it for free?",
    answer: "It’s for FREE! Exclusive for Skilltech app users, consider it a digital high-five from us to you. All you have to do is to focus on passing the exams, and we’ll take care of the reward at the end of your licensure journey!",
  },
  {
    question: "How do I claim it?",
    answer: "Simply complete the Scorecard section, which becomes accessible once you purchase the CAAP Knowledge Reviewer or any Bundle offer. After finishing the Scorecard, proceed to the Reward Claim section—unlocked upon completion—where you can provide your shipping address and other required details.",
  },
  {
    question: "What is a Scorecard?",
    answer: "The Scorecard is part of the Achievement Box reward requirements, where you are asked to manually input your actual CAAP Knowledge Test results into the platform. This process supports our research initiative, helping us maintain accuracy in our standards and assist fellow airmen in achieving their licensure goals.",
  },
  {
    question: "How do I complete the Scorecard?",
    answer: "After taking your CAAP exam, select the subject you want to update and enter your actual exam results into the Scorecard. Follow the on-screen steps and fill out each field as accurately as possible. Submit your results and save your progress. Once you’ve completed all subjects, you’ll be eligible to claim your reward.",
  },
  {
    question: "When should I start filling out my Scorecard?",
    answer: "It’s best to update your Scorecard on the same day you take your exam. Whether you pass or fail, every piece of information you provide helps improve the app and support the community.",
  },
  {
    question: "Is there a deadline for claiming the A-Box reward?",
    answer: "Yes. Please complete the A-Box claiming process within 30 days after passing all subjects in your CAAP Knowledge Test. Claims submitted beyond this period may no longer be accepted.",
  },
  {
    question: "Can I still claim my A-Box after my subscription has expired?",
    answer: "Yes. As long as you purchased the CAAP Knowledge Reviewer, the A-Box claiming option will remain available. However, your claim will still be subject to verification, including the requirement to claim within 30 days after passing all subjects in your actual CAAP Knowledge Test.",
  },
  {
    question: "Do I need to submit my Knowledge Test Report (KTR)?",
    answer: "Yes. Submitting your KTR is an essential part of our verification process. It allows us to confirm that the results you entered in your Scorecard are truthful and accurate.",
  },
  {
    question: "How long does it take to ship my A-Box?",
    answer: "Once your submission is approved, your A-Box will be shipped to your provided address free of charge and should arrive within 15 days. You’ll also receive an email with your delivery tracking information.",
  },
  {
    question: "What if I’m having problems with the requirements for the A-Box claim?",
    answer: "If you’re unable to complete your claim within the deadline—such as experiencing delays in obtaining your KTR—you may request an extension by emailing us at support@skilltech.ph",
  },
  {
    question: "Is posting my results on your social media a requirement for the A-Box?",
    answer: "Yes. As part of our mission to encourage and inspire other airmen to pursue their CAAP License, we ask successful candidates to allow us to share their exam results on our social media platforms. This helps motivate others and celebrate your achievement.",
  },
]

exports.faqData = {
  faqsPurchase, faqsReviewers, faqsMilestonesAchievements, faqsLeaderboards, faqsLeaderboardChallenge, faqsCaapLicenseTracker, faqsABox
}